import { Box, Flex, Spinner } from '@chakra-ui/react';
import { MessagingErrorIcon } from '@halo/ui-chat-react';

interface MessageEditProps {
  isEditing: boolean;
  isFailed: boolean;
  onClickError?: () => void;
}

export function MessageEdit({ isEditing, isFailed, onClickError }: MessageEditProps) {
  return (
    <Flex
      className="MessageEdit"
      alignItems="center"
      gap="1"
      w="full"
      cursor={isFailed ? 'pointer' : 'default'}
      justifyContent="flex-end"
      onClick={() => {
        if (isFailed) {
          onClickError?.();
        }
      }}
      fontSize="md"
    >
      {isFailed && (
        <>
          <MessagingErrorIcon />
          <Box fontSize="xs" color="fg.error">
            Update failed, Click to retry
          </Box>
        </>
      )}
      {isEditing && (
        <>
          <Spinner size="xs" color="brand.100" />
          <Box fontSize="xs" color="brand.100">
            Updating...
          </Box>
        </>
      )}
    </Flex>
  );
}
